import Box from '@mui/material/Box';

export default function BulkOperationProgressStack({
  children,
}: React.PropsWithChildren) {
  return (
    <Box
      data-test-id="bulk-operation-progress-stack"
      sx={(theme) => ({
        alignItems: 'flex-end',
        bottom: `calc(${theme.spacing(2)} + var(--tread-agent-dock-height, 0px))`,
        display: 'flex',
        // Children render oldest first, so each new card opens to the left of the last one.
        flexDirection: 'row-reverse',
        gap: 1,
        pointerEvents: 'none',
        position: 'fixed',
        right: theme.spacing(2),
        zIndex: theme.zIndex.snackbar,
        '& > *': { pointerEvents: 'auto' },
      })}
    >
      {children}
    </Box>
  );
}
